module.exports = "<svg viewBox=\"0 0 25.1 15.6\"><path fill=\"#231F20\" d=\"M7.8 15.6C3.5 15.6 0 12.1 0 7.8S3.5 0 7.8 0c2.1 0 3.9.7 5.3 2.1.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0-1-1-2.3-1.5-3.9-1.5C4.6 2 2 4.6 2 7.8s2.6 5.8 5.8 5.8c2.9 0 5-1.8 5.5-4.6v-.2H7.8c-.6 0-1-.4-1-1s.4-1 1-1h6.6c.6 0 1 .4 1 1 0 .5 0 1-.1 1.5-.7 3.8-3.6 6.3-7.5 6.3zM20.9 12c-.6 0-1-.4-1-1V4.6c0-.6.4-1 1-1s1 .4 1 1V11c0 .6-.5 1-1 1z\"></path><path fill=\"#231F20\" d=\"M24.1 8.8h-6.4c-.6 0-1-.4-1-1s.4-1 1-1h6.4c.6 0 1 .4 1 1s-.5 1-1 1z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/google-plus.svg
// module id = 303
// module chunks = 1